import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=3d4e3cef&scoped=true"
import script from "./EditTask.vue?vue&type=script&lang=js"
export * from "./EditTask.vue?vue&type=script&lang=js"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=3d4e3cef&prod&lang=css"
import style1 from "./EditTask.vue?vue&type=style&index=1&id=3d4e3cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e3cef",
  null
  
)

export default component.exports